
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-devices-teaser",
      function () {
        return require("private-next-pages/smart-devices-teaser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-devices-teaser"])
      });
    }
  